var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.001 18.215A11.784 11.784 0 0 0 8.262 20c6.468 0 11.712-5.164 11.712-11.534 0-.159-.003-.317-.01-.474.234-.181 1.681-1.323 2.036-2.058 0 0-1.175.481-2.325.595h-.008l.007-.004c.106-.07 1.587-1.063 1.788-2.246 0 0-.831.437-1.995.819-.193.063-.394.125-.602.182a4.128 4.128 0 0 0-3-1.28c-2.27 0-4.11 1.811-4.11 4.045 0 .315.037.622.106.917-.317-.013-5.148-.28-8.434-4.2 0 0-1.965 2.641 1.17 5.357 0 0-.953-.038-1.775-.521 0 0-.302 3.199 3.248 4.017 0 0-.698.26-1.813.075 0 0 .623 2.585 3.777 2.826 0 0-2.494 2.219-6.034 1.698h.001z",
    fill: "#888"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterGray);
export default __webpack_public_path__ + "static/media/twitter-gray.74a23a93156ac1da567323e94c658d3c.svg";
export { ForwardRef as ReactComponent };